import { render, staticRenderFns } from "./OriginatorDetail.vue?vue&type=template&id=e66d7fc4"
import script from "./OriginatorDetail.vue?vue&type=script&lang=js"
export * from "./OriginatorDetail.vue?vue&type=script&lang=js"
import style0 from "./OriginatorDetail.vue?vue&type=style&index=0&id=e66d7fc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports